import React, { useEffect, useState } from "react";
import { Title, Text } from "@/components/ui/text";
import { PiXBold } from "react-icons/pi";
import { ActionIcon } from "@/components/ui/action-icon";
import { Dispatch } from "react";
import { SetStateAction } from "jotai";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import Rate from "@/components/rate";
import { HeartIcon } from "@heroicons/react/24/solid";
import { Button } from "@/components/ui/button";
import { postUserRate } from "@/functions/axios/Rate/rate";
import { LoadingSpinner } from "@/components/ui/file-upload/upload-zone";

function getstatusheader(status: string) {
  switch (status.toLowerCase()) {
    case "bid":
      return "پیشنهاد جدید";
    case "warning":
      return "پیام اخطار";
    case "danger":
      return "پیام خطر";
    case "rating":
      return "امتیاز دادن";
    default:
      return status;
  }
}
const RatingModal = ({
  data,
  handleclose,
}: {
  data: any;
  handleclose: () => void;
}) => {
  const axiosAuth = useAxiosAuth();
  //   let value=0
  const [mmd, setMmd] = useState(0);

  let axios = useAxiosAuth();
  const [disabled, setDisabled] = useState(false);
  // let aref = new Aref();
  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  return (
    <>
      <div className="dark:bg-gray-100/90 overflow-hidden my-3 y-64 mx-3">
        <div className="col-span-full flex items-center justify-between pb-2 border-b-2 border-b-gray-200">
          <Title as="h4" className="font-semibold">
            {getstatusheader(data?.status)}
          </Title>
          <ActionIcon size="sm" variant="text" onClick={handleclose}>
            <PiXBold className="h-auto w-5" />
          </ActionIcon>
        </div>
        <div className="mb-4 mt-3 ">
          <Text>{data?.message}</Text>

          <Rate
            className="my-3 mr-3"
            character={<HeartIcon className="w-6" />}
            defaultValue={1.5}
            allowHalf
            value={mmd}
            onChange={(prop) => setMmd(prop)}
            size="xl"
          />
          <div className=" flex flex-row justify-end ml-5 ">
            <Button
              disabled={disabled}
              onClick={async () => {
                if (
                  data.target_rate.id &&
                  data.advertisement.id &&
                  mmd &&
                  data
                ) {
                  setDisabled(true);
                }
                if (!disabled) {
                  handleclose();
                  let res = postUserRate(
                    {
                      user_being_liked: data.target_rate.id,
                      advertisement: data.advertisement.id,
                      rate: mmd,
                      notification: data.id,
                    },
                    axios
                  );
                }
                async function checkCondition() {
                  if (disabled) {
                    await delay(3000); // Wait for 3 seconds
                    // Your code after the delay
                    handleclose();
                  }
                }
              }}
              className="w-1/4"
            >
              ثبت رای
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingModal;
